import { Component, OnInit, ElementRef } from '@angular/core';

@Component({
  selector: 'tog-tooltip-button-dropdown',
  templateUrl: './tooltip-button-dropdown.component.html',
  styleUrls: ['./tooltip-button-dropdown.component.scss'],
  host: {
    '(document:click)' : 'dismiss($event)'
  }
})
export class TooltipButtonDropdownComponent implements OnInit {

  constructor(private _el: ElementRef) { }

  ngOnInit() {
  }

  dismiss(e) {
    if (!this._el.nativeElement.parentNode.parentNode.contains(e.target)) { // or some similar check
      this._el.nativeElement.classList.remove('active');
    }
  }
}



// WEBPACK FOOTER //
// /app/src/app/shared/components/tooltip-button-dropdown/tooltip-button-dropdown.component.ts